import { render, staticRenderFns } from "./VermittelCounterApp.vue?vue&type=template&id=52c3f6ed&"
import script from "./VermittelCounterApp.vue?vue&type=script&lang=js&"
export * from "./VermittelCounterApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports